// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1108":"9647e65a","1364":"aa153da1","9897":"66f80b47","9940":"9e97cc04"}[chunkId] + ".chunk.css";
};